import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "helper/global";

const initialState = {
  name: null,
  logoUrl: null,
  logoHeight: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ORG_LOAD:
      return updateObject(state, {
        ...action,
      });

    default:
      return state;
  }
};

export default reducer;
